(function (ng) {
    // Directive to scroll a specified element a specified direction when the bound element in clicked
    ng.module("evo.Compare.Directives").directive('scroll', ['$document', '$timeout', '$window', function ($document, $timeout, $window) {
        return {
            restrict: 'A',
            scope: {
                target: '@scroll',
                scrollDirection: '@',
                watch: '=scrollWatch'
            },
            link: function ($scope, $el) {
                var $this = ng.element($el),
                    $win = ng.element($window),
                    winWidth = $win.width();

                // Show / hide button as based on current scroll amount
                function setButtonVisibility() {
                    var $target = ng.element($scope.target),
                        scrollLeft = $target.scrollLeft(),
                        innerWidth = $target[0].scrollWidth;

                    if (($scope.scrollDirection == 'left' && scrollLeft <= 0)
                        || ($scope.scrollDirection == 'right' && scrollLeft >= (innerWidth - $target.width()))) {
                        $this.addClass('inactive');
                    }
                    else {
                        $this.removeClass('inactive');
                    }
                };

                // Scroll in the specified direction
                function scroll(direction) {
                    var $target = ng.element($scope.target),
                        childAmount = $target.find('th:not(:first-child)').first().outerWidth(),
                        currentScroll = $target.scrollLeft();

                    $target.animate({
                        scrollLeft: currentScroll + (direction == 'left' ? -1 : 1) * childAmount
                    });
                };

                //listen for keyboard arrow keys to adjust view left/right
                $document.bind('keyup', function (event) {
                    if (event.target.nodeName === 'INPUT') {
                        return;
                    }
                    switch (event.keyCode) {
                        case 37: //left
                            $scope.scrollDirection == 'left' && scroll('left');
                            break;
                        case 39: //right
                            $scope.scrollDirection == 'right' && scroll('right');
                            break;
                        default:
                            return;
                    }
                    $scope.$apply();
                });

                $win.on('resize', function () {
                    var width = $win.width();
                    if (width != winWidth) {
                        winWidth = width;
                        setButtonVisibility();
                    }
                });

                $scope.$watchCollection('watch', function () {
                    $timeout(setButtonVisibility, 10);
                });
                ng.element($scope.target).on('scroll', setButtonVisibility);
                $this.on('click', function () { scroll($scope.scrollDirection); });

                //setButtonVisibility();
            }
        };
    }]);
})(angular);